import {useCallback, useEffect, useRef, useState} from "react";
import {AlertCircle, Play, Square} from 'lucide-react';
import {paper} from "paper/dist/paper-full.min";

const useMediaPipePose = (videoRef, canvasRef, isActive, onPoseDetected,img1) => {
    const poseRef = useRef(null);
    const [isReady, setIsReady] = useState(false);
    const [error, setError] = useState(null);
    const animationFrameRef = useRef(null);
    const processingRef = useRef(false);
    const lastFrameTimeRef = useRef(0);
    const extractAngles = (landmarks) => {
        if (!landmarks || landmarks.length < 33) return null;

        return {
            leftKnee: calculateAngle(
                landmarks[23], // left hip
                landmarks[25], // left knee
                landmarks[27]  // left ankle
            ),
            rightKnee: calculateAngle(
                landmarks[24], // right hip
                landmarks[26], // right knee
                landmarks[28]  // right ankle
            ),
            leftShoulder: calculateAngle(
                landmarks[11], // left shoulder
                landmarks[13], // left elbow
                landmarks[15]  // left wrist
            ),
            rightShoulder: calculateAngle(
                landmarks[12], // right shoulder
                landmarks[14], // right elbow
                landmarks[16]  // right wrist
            ),
            leftHip: calculateAngle(
                landmarks[11], // left shoulder
                landmarks[23], // left hip
                landmarks[25]  // left knee
            ),
            rightHip: calculateAngle(
                landmarks[12], // right shoulder
                landmarks[24], // right hip
                landmarks[26]  // right knee
            )
        };
    };
    const lg_CONNECTIONS = [
        [11, 13,1], [13, 15,1],  [12, 14,1], [14, 16,1],
        [23, 25,0.7],  [24, 26,0.7], [26, 28,0.7],[12,24,0.6],[11,23,0.6]
    ];
    const spine = [
        [7, 8,.5],[12, 11,.7],[24, 23,1]
    ];
    useEffect(() => {


       // if (!isActive || !videoRef.current || !canvasRef.current) return;

        let isMounted = true;

        const initializePose = async () => {


            try {

                // Wait for MediaPipe to load with retry logic
                let retries = 0;
                while (typeof window.Pose === 'undefined' && retries < 20) {
                    await new Promise(resolve => setTimeout(resolve, 300));
                    retries++;
                }

                if (typeof window.Pose === 'undefined') {
                    setError('MediaPipe libraries not loaded. Please refresh the page.');
                    return;
                }

                const pose = new window.Pose({
                    locateFile: (file) => {

                        return `https://cdn.jsdelivr.net/npm/@mediapipe/pose/${file}`;
                    }
                });

                pose.setOptions({
                    static_image_mode: true,
                    modelComplexity: 2,
                    smoothLandmarks: false,
                    enableSegmentation: true,
                    minDetectionConfidence: 0.5,
                    minTrackingConfidence: 0.5,
                    output_segmentation_masks:true
                });

                pose.onResults((results) => {
                    if (!isMounted) return;

                    const canvas = canvasRef.current;
                    if (!canvas) return;
                 //   const ctx = canvas.getContext('2d');
                  //  ctx.save();
                  //  ctx.clearRect(0, 0, canvas.width, canvas.height);

                    paper.setup(canvasRef.current);
                   const sca = canvasRef.current.clientWidth/img1.current.naturalWidth
                console.log(results)
                    const initGroup= new paper.Group();
                    initGroup.applyMatrix=false;
                    paper.project.activeLayer.addChild(initGroup);
                    if (results.segmentationMask){


                        var raster = new paper.Raster({size:new paper.Size(img1.current.naturalWidth,
                                img1.current.naturalHeight),position:new paper.Point(canvasRef.current.clientWidth/2, canvasRef.current.clientHeight/2)});
                        raster.scale(sca);
                        raster.opacity=0.5;
raster.drawImage(results.segmentationMask,new paper.Point(0,0));


                        // paper.project.activeLayer.addChild(raster)

                     /*   ctx.drawImage(results.segmentationMask,0,0); */
                    }



                    var from = new paper.Point(canvasRef.current.clientWidth/2, canvasRef.current.clientHeight/2);
                    var to = new paper.Point(canvasRef.current.width/2,canvasRef.current.height/2);

                   // return;


                    if (results.poseLandmarks) {
                        // Enhanced skeleton drawing with color-coded joints
                        const connections = window.POSE_CONNECTIONS;
                        let longest=0;
                       lg_CONNECTIONS.forEach(([start, end,c]) => {
                            const startPoint = results.poseLandmarks[start];
                            const endPoint = results.poseLandmarks[end];

                            //ctx.beginPath();
                            from = new paper.Point(startPoint.x * canvasRef.current.clientWidth, startPoint.y * canvasRef.current.clientHeight);
                            to = new paper.Point(endPoint.x * canvasRef.current.clientWidth, endPoint.y * canvasRef.current.clientHeight);
                           longest=Math.max(from.subtract(to).length*c,longest);
                        })

                        spine.forEach(([start, end,c],i) => {
                            const startPoint = results.poseLandmarks[start];
                            const endPoint = results.poseLandmarks[end];

                            //ctx.beginPath();
                            from=new paper.Point(startPoint.x * canvasRef.current.clientWidth, startPoint.y * canvasRef.current.clientHeight);
                            to=new paper.Point(endPoint.x * canvasRef.current.clientWidth, endPoint.y * canvasRef.current.clientHeight);
const mid=from.add(to).divide(2);
spine[i][3]=mid;
if(i>0){
    var tom=spine[i-1][3];
    var path = new paper.Path.Line(mid, tom);
    path.strokeColor = 'black';
    paper.project.activeLayer.addChild(path)
}else{
    var path = new paper.Path.Circle(mid, longest*.25);
    path.strokeColor = 'black';
    paper.project.activeLayer.addChild(path)
}
                        })
                            // Draw connections with gradient effect
                        connections.forEach(([start, end]) => {
                            const startPoint = results.poseLandmarks[start];
                            const endPoint = results.poseLandmarks[end];

                            //ctx.beginPath();
                            from=new paper.Point(startPoint.x * canvasRef.current.clientWidth, startPoint.y * canvasRef.current.clientHeight);
                            to=new paper.Point(endPoint.x * canvasRef.current.clientWidth, endPoint.y * canvasRef.current.clientHeight);

                            var path = new paper.Path.Line(from, to);
                            path.strokeColor = 'black';
                            paper.project.activeLayer.addChild(path)

                            // Color code based on body part
                            let color = '#00FF00'; // Default green
                            if (start >= 11 && start <= 16 || end >= 11 && end <= 16) {
                                color = '#3B82F6'; // Blue for arms
                            } else if (start >= 23 && start <= 28 || end >= 23 && end <= 28) {
                                color = '#F59E0B'; // Orange for legs
                            } else if (start >= 0 && start <= 10 || end >= 0 && end <= 10) {
                                color = '#10B981'; // Emerald for torso/head
                            }

                           // ctx.strokeStyle = color;
                          //  ctx.lineWidth =5;
                          //  ctx.lineCap = 'round';
                           // ctx.stroke();
                        });

                       const keyJoints = [[11,.7], [12,.7], [13,.3], [14,.3], [15,.2], [16,.2], [23,1], [24,1], [25,.7], [26,.7], [29,.5], [30,.5]];

                        // Draw landmarks with different sizes for key joints
                        keyJoints.forEach(ix => {
                            const landmark = results.poseLandmarks[ix[0]];

                            const x = landmark.x * canvasRef.current.clientWidth;
                            const y = landmark.y * canvasRef.current.clientHeight;
                            var path = new paper.Path.Circle(new paper.Point(x, y), longest*.22*ix[1]*(1-landmark.z/2));
                            path.strokeColor = 'black';
                            paper.project.activeLayer.addChild(path)
                            // Key joints (shoulders, elbows, hips, knees, ankles)
                         /*
                            const isKeyJoint = keyJoints.includes(index);


                            let color;
                            if (index >= 11 && index <= 16) {
                                color = isKeyJoint ? '#3B82F6' : '#60A5FA';
                            } else if (index >= 23 && index <= 28) {
                                color = isKeyJoint ? '#F59E0B' : '#FCD34D';
                            } else {
                                color = isKeyJoint ? '#10B981' : '#34D399';
                            }

                            ctx.strokeStyle = color;
                            ctx.lineWidth =5;
                            ctx.lineCap = 'round';
                            ctx.stroke();
*/
                            // Add white border for visibility

                        });

                       return;
                    }

                    //ctx.restore();
                    processingRef.current = false;
                });

                poseRef.current = pose;

                // Manual frame processing with throttling
                const processFrame = async () => {
                    if (!isMounted || !videoRef.current || !poseRef.current) return;

                    const now = Date.now();
                    const timeSinceLastFrame = now - lastFrameTimeRef.current;

                    // Process at ~30 FPS (every 33ms) to prevent overload
                    if (timeSinceLastFrame >= 33) {
                        try {
                            if (videoRef.current.readyState === videoRef.current.HAVE_ENOUGH_DATA && !processingRef.current) {
                                processingRef.current = true;
                                lastFrameTimeRef.current = now;
                                await poseRef.current.send({ image: videoRef.current });
                            }
                        } catch (err) {
                            console.error('Frame processing error:', err);
                            processingRef.current = false;
                        }
                    }

                    animationFrameRef.current = requestAnimationFrame(processFrame);
                };

                // Start processing frames
                setIsReady(true);
                processFrame();

            } catch (err) {
                console.error('MediaPipe error:', err);
                if (isMounted) {
                    setError('Failed to initialize pose tracking. Please refresh.');
                }
            }
        };

        initializePose();

        return () => {
            isMounted = false;
            processingRef.current = false;
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
            }
            if (poseRef.current) {
                try {
                    poseRef.current.close();
                } catch (err) {
                    console.error('Error closing pose:', err);
                }
            }
        };
    }, [isActive, videoRef, canvasRef, onPoseDetected]);

    return { isReady, error ,poseRef};
};
export  const Tracker= ({ exercise, onComplete, voiceEnabled }) => {
    const [reps, setReps] = useState(0);
    const [phase, setPhase] = useState('ready');
    const [feedback, setFeedback] = useState('Position yourself in camera view');
    const [secondaryFeedback, setSecondaryFeedback] = useState('');
    const [accuracy, setAccuracy] = useState([]);
    const [isTracking, setIsTracking] = useState(false);
    const [currentAngle, setCurrentAngle] = useState(0);
    const [progress, setProgress] = useState(0);
    const [poseDetected, setPoseDetected] = useState(true);
    const fl = useRef(null);
    const img1 = useRef(null);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const lastPhaseRef = useRef('ready');
    const lastFeedbackRef = useRef('');
    const lastSpeakTimeRef = useRef(0);
    const repInProgressRef = useRef(false);
    const frameCountRef = useRef(0);
    const perfectHoldCountRef = useRef(0);
    const noPoseCountRef = useRef(0);

    const speak = useCallback((text, priority = 'normal') => {
        if (!voiceEnabled || !('speechSynthesis' in window)) return;

        const now = Date.now();
        const timeSinceLastSpeak = now - lastSpeakTimeRef.current;

        // More responsive timing
        const delays = { high: 0, normal: 800, low: 1500 };
        const delay = delays[priority] || 800;

        if (text !== lastFeedbackRef.current || timeSinceLastSpeak > delay) {
            speechSynthesis.cancel();
            const utterance = new SpeechSynthesisUtterance(text);
            utterance.rate = 1.15; // Slightly faster, more natural
            utterance.pitch = 1.05; // More enthusiastic
            utterance.volume = 1.0;

            // Try to use a more natural voice if available
            const voices = speechSynthesis.getVoices();
            const preferredVoice = voices.find(v => v.name.includes('Samantha') || v.name.includes('Karen')) || voices[0];
            if (preferredVoice) utterance.voice = preferredVoice;

            speechSynthesis.speak(utterance);
            lastSpeakTimeRef.current = now;
            lastFeedbackRef.current = text;
        }
    }, [voiceEnabled]);

    const handlePoseDetected = useCallback((angles) => {
        frameCountRef.current++;
        noPoseCountRef.current = 0;
        setPoseDetected(true);

        let jointAngle = 0;
        switch (exercise.jointType) {
            case 'knee':
                jointAngle = Math.min(angles.leftKnee, angles.rightKnee);
                break;
            case 'shoulder':
                jointAngle = Math.max(angles.leftShoulder, angles.rightShoulder);
                break;
            case 'hip':
                jointAngle = Math.min(angles.leftHip, angles.rightHip);
                break;
            default:
                jointAngle = angles.leftKnee;
        }

        setCurrentAngle(Math.round(jointAngle));

        const [targetMin, targetMax] = exercise.targetAngles[exercise.jointType];
        const readyAngle = exercise.readyAngle;

        // Calculate progress (0-100%)
        if (jointAngle < readyAngle) {
            const progressValue = Math.min(100, Math.max(0,
                ((readyAngle - jointAngle) / (readyAngle - targetMin)) * 100
            ));
            setProgress(Math.round(progressValue));
        } else {
            setProgress(0);
        }

        let newPhase = phase;
        let mainFeedback = '';
        let secondFeedback = '';

        // Phase detection with more granular feedback
        if (jointAngle >= readyAngle) {
            newPhase = 'ready';
            mainFeedback = exercise.feedback.ready;

            if (lastPhaseRef.current === 'perfect' && repInProgressRef.current) {
                setReps(r => r + 1);
                setAccuracy(acc => [...acc, 100]);
                speak('Excellent rep! Keep it up', 'high');
                repInProgressRef.current = false;
                perfectHoldCountRef.current = 0;
            }

            if (lastPhaseRef.current !== 'ready' && frameCountRef.current % 60 === 0) {
                speak('Ready for next rep', 'normal');
            }

        } else if (jointAngle < readyAngle && jointAngle > targetMax + 20) {
            newPhase = 'descending';
            mainFeedback = exercise.feedback.starting;
            repInProgressRef.current = true;

            if (jointAngle > targetMax + 40) {
                secondFeedback = 'Keep going down';
                if (frameCountRef.current % 35 === 0) {
                    speak('Good start, keep going', 'low');
                }
            } else {
                secondFeedback = exercise.feedback.almostThere;
                if (frameCountRef.current % 30 === 0) {
                    speak('Almost there, little more', 'normal');
                }
            }

        } else if (jointAngle > targetMax && jointAngle <= targetMax + 20) {
            newPhase = 'almost';
            mainFeedback = exercise.feedback.almostThere;

            if (exercise.jointType === 'knee') {
                secondFeedback = 'A bit deeper';
                if (frameCountRef.current % 25 === 0) {
                    speak('Go a bit deeper', 'normal');
                }
            } else if (exercise.jointType === 'shoulder') {
                secondFeedback = 'Raise higher';
                if (frameCountRef.current % 25 === 0) {
                    speak('Raise your arms higher', 'normal');
                }
            } else {
                secondFeedback = 'Almost perfect';
            }

        } else if (jointAngle >= targetMin && jointAngle <= targetMax) {
            newPhase = 'perfect';
            mainFeedback = exercise.feedback.perfect;
            perfectHoldCountRef.current++;

            if (perfectHoldCountRef.current === 15) {
                speak('Perfect form! Hold this', 'high');
                secondFeedback = 'Hold for 2 seconds';
            } else if (perfectHoldCountRef.current === 45) {
                speak('Great! Now come back up', 'high');
            } else if (perfectHoldCountRef.current > 15 && perfectHoldCountRef.current < 45) {
                secondFeedback = 'Holding strong!';
            }

        } else if (jointAngle < targetMin) {
            newPhase = 'too_low';
            mainFeedback = exercise.feedback.tooLow;
            secondFeedback = 'Come up slightly';

            if (frameCountRef.current % 25 === 0) {
                speak('Too low, come up a bit', 'normal');
            }
        }

        // Enhanced form corrections with more specific feedback
        if (exercise.jointType === 'knee') {
            if (angles.torsoAngle < 150) {
                secondFeedback = 'Straighten your back';
                if (frameCountRef.current % 40 === 0) {
                    speak('Keep your back straight', 'high');
                }
            }

            // Check knee alignment
            const kneeDiff = Math.abs(angles.leftKnee - angles.rightKnee);
            if (kneeDiff > 15 && newPhase !== 'ready') {
                secondFeedback = 'Balance both knees';
                if (frameCountRef.current % 50 === 0) {
                    speak('Keep both knees even', 'normal');
                }
            }
        } else if (exercise.jointType === 'shoulder') {
            const avgElbow = (angles.leftElbow + angles.rightElbow) / 2;
            if (avgElbow < 160 && newPhase !== 'ready') {
                secondFeedback = 'Straighten arms';
                if (frameCountRef.current % 40 === 0) {
                    speak('Keep your arms straight', 'high');
                }
            }

            // Check arm symmetry
            const armDiff = Math.abs(angles.leftShoulder - angles.rightShoulder);
            if (armDiff > 20 && newPhase !== 'ready') {
                secondFeedback = 'Keep arms level';
                if (frameCountRef.current % 50 === 0) {
                    speak('Raise both arms evenly', 'normal');
                }
            }
        } else if (exercise.jointType === 'hip') {
            // Balance check for single leg exercises
            if (frameCountRef.current % 60 === 0 && newPhase === 'perfect') {
                speak('Keep your balance', 'low');
            }
        }

        lastPhaseRef.current = newPhase;
        setPhase(newPhase);
        setFeedback(mainFeedback);
        setSecondaryFeedback(secondFeedback);

    }, [exercise, phase, speak]);

    const { isReady, error , poseRef} = useMediaPipePose(videoRef, canvasRef, isTracking, handlePoseDetected,img1);

    // Check for no pose detected
    useEffect(() => {

        if (!isTracking) return;

        const interval = setInterval(() => {
            noPoseCountRef.current++;
            if (noPoseCountRef.current > 10) { // 10 frames without detection
                setPoseDetected(false);
            }
        }, 100);

        return () => clearInterval(interval);
    }, [isTracking]);
    const startTracking = async ()=>{

        const poseLandmarkerResult = poseRef.current.send({ image: img1.current}).then(a=>console.log(a));


    }
        const startTracking_ = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    width: 640,
                    height: 480,
                    facingMode: 'user'
                }
            });

            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }

            setIsTracking(true);
            speak('Starting exercise. Position yourself so I can see your full body. Stand 6 to 8 feet from the camera', 'high');
            setFeedback('Initializing camera...');
        } catch (err) {
            console.error('Camera error:', err);
            setFeedback('❌ Camera access denied');
            speak('Camera access denied');
        }
    };
const rip = async (file) => {

    const img2 = new Image();

    img2.onload = () => {
        // Set canvas size to match the image
        img1.current=img2;
        canvasRef.current.height = img2.naturalHeight;
        canvasRef.current.width = img2.naturalWidth;

        const element = document.getElementById("im");
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
        document.getElementById('im').appendChild(img2);


    };

    img2.src = URL.createObjectURL(file);


}
    const stopTracking = () => {
        if (videoRef.current && videoRef.current.srcObject) {
            videoRef.current.srcObject.getTracks().forEach(track => track.stop());
        }

        speechSynthesis.cancel();
        setIsTracking(false);

        const avgAccuracy = accuracy.length > 0
            ? (accuracy.reduce((a, b) => a + b, 0) / accuracy.length).toFixed(1)
            : 0;

        speak(`Workout complete. You completed ${reps} repetitions. Great job!`, 'high');

        setTimeout(() => {
            onComplete({
                reps,
                avgAccuracy,
                exercise: exercise.name,
                date: new Date().toISOString()
            });
        }, 2000);
    };

    return (
        <div className="exercise-tracker">
            <div className="video-section">
                <div className="video-container">
              <div id="im"></div>
                    <canvas
                        ref={canvasRef}
                        width="640"
                        height="480"
                        className="pose-canvas"
                    />



                    {error && (
                        <div className="error-overlay">
                            <AlertCircle size={32} />
                            <p>{error}</p>
                            <small>Please refresh the page</small>
                        </div>
                    )}

                    {isTracking && !poseDetected && (
                        <div className="warning-overlay">
                            <AlertCircle size={32} />
                            <p>⚠️ No pose detected</p>
                            <small>Step back and ensure your full body is visible</small>
                        </div>
                    )}


                </div>


            </div>

            <div className="exercise-info">

                <div className="controls-box">
                    {!isTracking ? (
                        <>
<input type="file" accept="image/*" ref={fl} onChange={()=>rip(fl.current.files[0])}/>
                        <button className="btn-start" onClick={startTracking}>
                            <Play size={24} />
                            Get Helper lines
                        </button>
                        </>
                    ) : (
                        <button className="btn-stop" onClick={stopTracking}>
                            <Square size={24} />
                            Stop & Save
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};